module.exports = __webpack_public_path__ + "img/student2.ee0784ca.png";